export enum MenuItemsCodeEnum {
    SMARTLY_NOTIFICATIONS_MENU_CODE = 'SMARTLY_NOTIFICATIONS',
    STORE360_NOTIFICATIONS_MENU_CODE = 'STORE360_NOTIFICATIONS'
}